import React from 'react';
import { Table, Tag, Button, Space, Popconfirm, message } from 'antd';

const SchemaList = ({ schemas = [], onEdit, onDelete }) => {
    const columns = [
        {
            title: 'Tên Schema',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Định dạng',
            dataIndex: 'format',
            key: 'format',
            render: (format) => <Tag color="blue">{format}</Tag>
        },
        {
            title: 'Mô tả',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Số Field Mapping',
            dataIndex: 'fieldMapping',
            key: 'fieldMapping',
            render: (mapping) => mapping?.length || 0,
        },
        {
            title: 'Hành động',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Button onClick={() => onEdit?.(record)} type="link">Sửa</Button>
                    <Popconfirm
                        title="Bạn có chắc chắn muốn xóa schema này không?"
                        onConfirm={() => {
                            onDelete?.(record);
                            message.success('Đã xóa schema');
                        }}
                        okText="Xóa"
                        cancelText="Hủy"
                    >
                        <Button type="link" danger>Xóa</Button>
                    </Popconfirm>
                </Space>
            )
        }
    ];

    const dataSource = schemas.map((s, index) => ({
        ...s,
        key: s.id || index
    }));

    return (
        <div style={{ padding: 16 }}>
            <h2>Danh sách Schema</h2>
            <Table columns={columns} dataSource={dataSource} bordered pagination={{ pageSize: 10 }} />
        </div>
    );
};

export default SchemaList;
